import { OpenLinesRecentModel } from '../recent/recent';
import { SessionsModel } from '../sessions/sessions';
import { QueueModel } from '../queue/queue';

export const OpenLinesModels = [
	OpenLinesRecentModel,
	SessionsModel,
	QueueModel,
];
